import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MARK_ITEM } from '../../../BlankEditor/type';
import { renderMarkElement } from './renderElement';

export const MarkToScrollPlugin = (): SlatePlugin => {
  return {
    renderElement: renderMarkElement(),
    inlineTypes: [MARK_ITEM],
  };
};
